import { InsightData } from 'schemas/action/InsightDataSchema'
import ThemeInfoListVo from 'vo/ThemeInfoListVo'
import {
  DashboardWidgetWithPivotThemeType,
  DashboardWidgetWithPivotRowThemeType
} from 'features/dashboard/types'
import { WidgetSettingComposingStrategy } from '../widgetSettingComposingStrategy'
import { DecoratedWidgetSettingComposingStrategy } from './type'

const resolveThemeInfos = (widgetSetting: DashboardWidgetWithPivotThemeType) => {
  const pivotThemeInfos = widgetSetting.pivotThemeInfos || []
  if ('pivotRowThemeInfos' in widgetSetting) {
    const { pivotRowThemeInfos } = widgetSetting as DashboardWidgetWithPivotRowThemeType
    return pivotThemeInfos.concat(pivotRowThemeInfos || [])
  }

  return pivotThemeInfos
}

const pivotThemeDecorator = (
  strategy: WidgetSettingComposingStrategy
): DecoratedWidgetSettingComposingStrategy => ({
  ...strategy,
  canBeDrilledDown: (widgetSetting: DashboardWidgetWithPivotThemeType) => {
    if (widgetSetting.themeInfos && widgetSetting.themeInfos.length >= 4) {
      return false
    }

    return strategy.canBeDrilledDown(widgetSetting)
  },
  composeDrillDownWidgetSetting: (
    widgetSetting: DashboardWidgetWithPivotThemeType,
    insights: InsightData[],
    pivots: InsightData[]
  ) => {
    const alteredWidgetSetting = strategy.composeDrillDownWidgetSetting(widgetSetting, insights)
    const themeInfos = resolveThemeInfos(widgetSetting)
    if (themeInfos.length === 0) {
      return alteredWidgetSetting
    }

    const matchedThemeInfos = pivots.map((pivot: InsightData) =>
      themeInfos.find((themeInfo) => themeInfo.themeId === parseInt(pivot.id!, 10))
    )

    if (matchedThemeInfos.length === 0) {
      return alteredWidgetSetting
    }

    return {
      ...alteredWidgetSetting,
      themeInfos: [
        ...(alteredWidgetSetting.themeInfos || []),
        ThemeInfoListVo({ themeInfos: matchedThemeInfos })
      ]
    }
  }
})

export default pivotThemeDecorator
